import {ProductFormReader} from '../vendor/theme-scripts/theme-product-form';

import SelloutVariants from './product-form-sellout';

const selectors = {
  product: '[data-product]',
  productForm: '[data-product-form]',
  productNotification: 'product-notification',
  variantTitle: '[data-variant-title]',
  notificationProduct: '[data-notification-product]',
  itemCountForVariant: '[data-item-count-for-variant]',
  maxInventory: '[data-max-inventory]',
  addToCart: '[data-add-to-cart]',
  addToCartText: '[data-add-to-cart-text]',
  cartPage: '[data-cart-page]',
  comparePrice: '[data-compare-price]',
  comparePriceText: '[data-compare-text]',
  finalSaleBadge: '[data-final-sale-badge]',
  colorDescriptionMetafield: '[data-color-description-metafield]',
  colorDescription: '[data-color-description]',
  formWrapper: '[data-form-wrapper]',
  originalSelectorId: '[data-product-select]',
  priceWrapper: '[data-price-wrapper]',
  productImages: 'product-images',
  productImage: '[data-product-image]',
  productMediaList: '[data-product-media-list]',
  productJson: '[data-product-json]',
  productPrice: '[data-product-price]',
  productUpsell: '[data-product-upsell-ajax]',
  unitPrice: '[data-product-unit-price]',
  unitBase: '[data-product-base]',
  unitWrapper: '[data-product-unit]',
  productPreorderInput: '[data-product-preorder]',
  productSlide: '.product__slide',
  subPrices: '[data-subscription-watch-price]',
  subSelectors: '[data-subscription-selectors]',
  subsToggle: '[data-toggles-group]',
  subsChild: 'data-group-toggle',
  subDescription: '[data-plan-description]',
  section: '[data-section-type]',
  variantSku: '[data-variant-sku]',
  variantMetafields: '[data-variant-metafields]',
  variantButtons: '[data-variant-buttons]',
  variantOptionImage: '[data-variant-option-image]',
  quickAddModal: '[data-quick-add-modal]',
  priceOffAmount: '[data-price-off-amount]',
  priceOffBadge: '[data-price-off-badge]',
  priceOffType: '[data-price-off-type]',
  priceOffWrap: '[data-price-off]',
  remainingCount: '[data-remaining-count]',
  remainingMax: '[data-remaining-max]',
  remainingWrapper: '[data-remaining-wrapper]',
  remainingJSON: '[data-product-remaining-json]',
  optionValue: '[data-option-value]',
  optionPosition: '[data-option-position]',
  installment: '[data-product-form-installment]',
  inputId: 'input[name="id"]',
};

const classes = {
  hidden: 'hidden',
  variantSoldOut: 'variant--soldout',
  variantUnavailable: 'variant--unavailable',
  productPriceSale: 'product__price--sale',
  remainingLow: 'count-is-low',
  remainingIn: 'count-is-in',
  remainingOut: 'count-is-out',
  remainingUnavailable: 'count-is-unavailable',
};

const attributes = {
  remainingMaxAttr: 'data-remaining-max',
  enableHistoryState: 'data-enable-history-state',
  notificationPopup: 'data-notification-popup',
  faderDesktop: 'data-fader-desktop',
  faderMobile: 'data-fader-mobile',
  optionPosition: 'data-option-position',
  imageId: 'data-image-id',
  mediaId: 'data-media-id',
  quickAddButton: 'data-quick-add-btn',
  finalSale: 'data-final-sale',
  variantImageScroll: 'data-variant-image-scroll',
  maxInventoryReached: 'data-max-inventory-reached',
  errorMessagePosition: 'data-error-message-position',
  preorderTypeProduct: 'data-preorder-type-product',
};

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',

    class ProductForm extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        if (this.hasAttribute('onboarding')) return;

        this.cartAddEvents();

        this.container = this.closest(selectors.section) || this.closest(selectors.quickAddModal);
        if (!this.container) return;

        this.sectionId = this.container.dataset.sectionId;
        this.product = this.container.querySelector(selectors.product);
        this.productForm = this.container.querySelector(selectors.productForm);
        this.productNotification = this.container.querySelector(selectors.productNotification);
        this.productImages = this.container.querySelector(selectors.productImages);
        this.productMediaList = this.container.querySelector(selectors.productMediaList);
        this.installmentForm = this.container.querySelector(selectors.installment);
        this.skuWrapper = this.container.querySelector(selectors.variantSku);
        this.sellout = null;
        this.variantImageScroll = this.container.getAttribute(attributes.variantImageScroll) === 'true';

        this.priceOffWrap = this.container.querySelector(selectors.priceOffWrap);
        this.priceOffAmount = this.container.querySelector(selectors.priceOffAmount);
        this.priceOffType = this.container.querySelector(selectors.priceOffType);
        this.planDescription = this.container.querySelector(selectors.subDescription);

        this.remainingWrapper = this.container.querySelector(selectors.remainingWrapper);

        this.colorDescriptionMetafield = this.container.querySelector(selectors.colorDescriptionMetafield);
        this.colorDescription = this.container.querySelector(selectors.colorDescription);
        this.colorDescriptionData = null;

        if (this.colorDescriptionMetafield && this.colorDescriptionMetafield.textContent) {
          try {
            this.colorDescriptionData = JSON.parse(this.colorDescriptionMetafield.textContent);
          } catch (e) {
            console.warn('Error parsing color description metafield data:', e);
          }
        }

        if (this.remainingWrapper) {
          const remainingMaxWrap = this.container.querySelector(selectors.remainingMax);
          if (remainingMaxWrap) {
            this.remainingMaxInt = parseInt(remainingMaxWrap.getAttribute(attributes.remainingMaxAttr), 10);
            this.remainingCount = this.container.querySelector(selectors.remainingCount);
            this.remainingJSONWrapper = this.container.querySelector(selectors.remainingJSON);
            this.remainingJSON = null;

            if (this.remainingJSONWrapper && this.remainingJSONWrapper.innerHTML !== '') {
              this.remainingJSON = JSON.parse(this.remainingJSONWrapper.innerHTML);
            } else {
              console.warn('Missing product quantity JSON');
            }
          }
        }

        this.preorderInput = this.container.querySelector(selectors.productPreorderInput);
        this.enableHistoryState = this.container.getAttribute(attributes.enableHistoryState) === 'true';
        this.hasUnitPricing = this.container.querySelector(selectors.unitWrapper);
        this.subSelectors = this.container.querySelector(selectors.subSelectors);
        this.subPrices = this.container.querySelector(selectors.subPrices);
        this.isPreOrder = this.container.querySelector(selectors.isPreOrder);

        let productJSON = null;
        const productElemJSON = this.container.querySelector(selectors.productJson);
        if (productElemJSON) {
          productJSON = productElemJSON.innerHTML;
        }
        if (productJSON) {
          this.productJSON = JSON.parse(productJSON);
          this.linkForm();
          this.sellout = new SelloutVariants(this.container, this.productJSON);
        } else {
          console.error('Missing product JSON');
        }

        this.variantOptionImages = this.container.querySelectorAll(selectors.variantOptionImage);
        this.variantButtons = this.container.querySelectorAll(selectors.variantButtons);
        if (this.variantOptionImages.length > 1) {
          this.optionImagesWidth();
        }
      }

      cartAddEvents() {
        this.buttonATC = this.querySelector(selectors.addToCart);

        this.buttonATC.addEventListener('click', (e) => {
          e.preventDefault();

          document.dispatchEvent(
            new CustomEvent('theme:cart:add', {
              detail: {
                button: this.buttonATC,
              },
              bubbles: false,
            })
          );

          if (!this.closest(selectors.quickAddModal)) {
            window.a11y.lastElement = this.buttonATC;
          }
        });
      }

      destroy() {
        this.productForm.destroy();
      }

      linkForm() {
        this.productForm = new ProductFormReader(this.container, this.productJSON, {
          onOptionChange: this.onOptionChange.bind(this),
          onPlanChange: this.onPlanChange.bind(this),
          onQuantityChange: this.onQuantityChange.bind(this),
        });
        this.pushState(this.productForm.getFormState(), true);
        this.subsToggleListeners();

        this.checkLiveCartInfoCallback = () => this.checkLiveCartInfo();
        document.addEventListener('theme:cart-drawer:close', this.checkLiveCartInfoCallback);
      }

      onOptionChange(evt) {
        this.pushState(evt.dataset);
      }

      onPlanChange(evt) {
        if (this.subPrices) {
          this.pushState(evt.dataset);
        }
      }

      onQuantityChange(evt) {
        this.pushState(evt.dataset);
      }

      pushState(formState, init = false) {
        this.productState = this.setProductState(formState);
        this.updateAddToCartState(formState);
        this.updateNotificationForm(formState);
        this.updateProductPrices(formState);
        this.updateProductImage(formState);
        this.updateSaleText(formState);
        this.updateSku(formState);
        this.updateSubscriptionText(formState);
        this.updateRemaining(formState);
        this.checkLiveCartInfo(formState);
        this.updateLegend(formState);
        this.updateColorDescription(formState);
        this.updatePreorderState(formState);
        this.fireHookEvent(formState);
        this.updateVariantMedia(formState);
        this.sellout?.update(formState);

        if (this.enableHistoryState && !init) {
          this.updateHistoryState(formState);
        }
      }

      updateVariantMedia(formState) {
        const variantId = formState.variant.id;
        const productUrl = this.getAttribute('data-product-url');
        const fetchUrl = `${productUrl}?variant=${variantId}`;
        const imageContainer = document.querySelector('product-images');
        if (this.firstLoad === true) {
          fetch(fetchUrl)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const badgeBgColor = html.querySelector('[data-badge-bg-color]');
              if (badgeBgColor) {
                document.querySelector('[data-price-off]').style.setProperty('--meta-bg-badge-color', badgeBgColor.getAttribute('data-badge-bg-color'));
              } else {
                document.querySelector('[data-price-off]').style.removeProperty('--meta-bg-badge-color');
              }
              const newProductImages = html.querySelector('product-images');
              const parent = imageContainer.parentNode;
              const clone = newProductImages.cloneNode(true);
              parent.replaceChild(clone, imageContainer);
            });
        }

        this.firstLoad = true;
      }

      updateAddToCartState(formState) {
        const variant = formState.variant;

        let addText = theme.strings.addToCart;
        const priceWrapper = this.container.querySelectorAll(selectors.priceWrapper);
        const addToCart = this.container.querySelectorAll(selectors.addToCart);
        const addToCartText = this.container.querySelectorAll(selectors.addToCartText);
        const formWrapper = this.container.querySelectorAll(selectors.formWrapper);

        if (this.installmentForm && variant) {
          const installmentInput = this.installmentForm.querySelector(selectors.inputId);
          installmentInput.value = variant.id;
          installmentInput.dispatchEvent(new Event('change', {bubbles: true}));
        }

        const variantPreorder = this.isVariantPreorder(variant);
        const productPreorder = this.hasAttribute(attributes.preorderTypeProduct);
        const preorderBadge = this.container.querySelector('[data-preorder-badge]');

        if (variantPreorder || productPreorder) {
          addText = theme.strings.preOrder;
        }

        if (!productPreorder) {
          preorderBadge?.classList.toggle('hidden', !variantPreorder);
        }

        if (theme.settings.atcButtonShowPrice) {
          const quantity = this.container.querySelector('quantity-counter input')?.value || 1;
          const totalPrice = variant.price * quantity;
          let priceText = totalPrice === 0 ? window.theme.strings.free : window.theme.formatMoney(totalPrice, theme.moneyFormat);

          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            const totalComparePrice = variant.compare_at_price * quantity;
            priceText = `${priceText} <s>${window.theme.formatMoney(totalComparePrice, theme.moneyFormat)}</s>`;
          }

          addText = `${addText} <span class="btn__price">${priceText}</span>`;
        }

        if (priceWrapper.length && variant) {
          priceWrapper.forEach((element) => {
            element.classList.remove(classes.hidden);
          });
        }

        addToCart?.forEach((button) => {
          if (button.hasAttribute(attributes.quickAddButton)) return;

          if (variant) {
            if (variant.available) {
              button.disabled = false;
            } else {
              button.disabled = true;
            }
          } else {
            button.disabled = true;
          }
        });

        addToCartText?.forEach((element) => {
          let btnText = addText;
          if (variant) {
            if (!variant.available) {
              btnText = theme.strings.soldOut;
            }
          } else {
            btnText = theme.strings.unavailable;
          }

          element.innerHTML = btnText;
        });

        if (formWrapper.length) {
          formWrapper.forEach((element) => {
            if (variant) {
              if (variant.available) {
                element.classList.remove(classes.variantSoldOut, classes.variantUnavailable);
              } else {
                element.classList.add(classes.variantSoldOut);
                element.classList.remove(classes.variantUnavailable);
              }

              const formSelect = element.querySelector(selectors.originalSelectorId);
              if (formSelect) {
                formSelect.value = variant.id;
              }

              const inputId = element.querySelector(`${selectors.inputId}[form]`);
              if (inputId) {
                inputId.value = variant.id;
                inputId.dispatchEvent(new Event('change'));
              }
            } else {
              element.classList.add(classes.variantUnavailable);
              element.classList.remove(classes.variantSoldOut);
            }
          });
        }
      }

      updateNotificationForm(formState) {
        if (!this.productNotification) return;

        const variantTitle = this.productNotification.querySelector(selectors.variantTitle);
        const notificationProduct = this.productNotification.querySelector(selectors.notificationProduct);

        if (variantTitle != null && notificationProduct != null) {
          variantTitle.textContent = formState.variant.title;
          if (notificationProduct) {
            notificationProduct.value = formState.variant.name;
          }
        }
      }

      updatePreorderState(formState) {
        if (!this.preorderInput) return;

        const isPreorder = this.isVariantPreorder(formState.variant) || this.hasAttribute(attributes.preorderTypeProduct);

        this.preorderInput.toggleAttribute('disabled', !isPreorder);
      }

      updateHistoryState(formState) {
        const variant = formState.variant;
        const plan = formState.plan;
        const location = window.location.href;
        if (variant && location.includes('/product')) {
          const url = new window.URL(location);
          const params = url.searchParams;
          params.set('variant', variant.id);
          if (plan && plan.detail && plan.detail.id && this.productState.hasPlan) {
            params.set('selling_plan', plan.detail.id);
          } else {
            params.delete('selling_plan');
          }
          url.search = params.toString();
          const urlString = url.toString();
          window.history.replaceState({path: urlString}, '', urlString);
        }
      }

      updateRemaining(formState) {
        const variant = formState.variant;

        this.remainingWrapper?.classList.remove(classes.remainingIn, classes.remainingOut, classes.remainingUnavailable, classes.remainingLow);

        if (variant && this.remainingWrapper && this.remainingJSON) {
          const remaining = this.remainingJSON[variant.id];

          if (remaining === 'out' || remaining < 1) {
            this.remainingWrapper.classList.add(classes.remainingOut);
          }

          if (remaining === 'in' || remaining >= this.remainingMaxInt) {
            this.remainingWrapper.classList.add(classes.remainingIn);
          }

          if (remaining === 'low' || (remaining > 0 && remaining < this.remainingMaxInt)) {
            this.remainingWrapper.classList.add(classes.remainingLow);

            if (this.remainingCount) {
              this.remainingCount.innerHTML = remaining;
            }
          }
        } else if (!variant && this.remainingWrapper) {
          this.remainingWrapper.classList.add(classes.remainingUnavailable);
        }
      }

      checkLiveCartInfo(formState) {
        const state = formState ? formState : this.productForm.getFormState();
        const variant = state.variant;
        if (!variant) return;

        const productUrl = `${theme.routes.root}products/${this.productJSON.handle}?section_id=api-live-cart-info&variant=${variant.id}`;

        fetch(productUrl)
          .then((response) => response.text())
          .then((data) => {
            const markup = new DOMParser().parseFromString(data, 'text/html');
            const itemCountForVariant = Number(markup.querySelector(selectors.itemCountForVariant).innerHTML);
            const maxInventory = markup.querySelector(selectors.maxInventory).innerHTML;
            const maxInventoryCount = Number(maxInventory);
            const addingMoreThanAvailable = Boolean(this.productForm.quantity() + itemCountForVariant > maxInventoryCount);

            const maxInventoryReached = maxInventory !== '' ? addingMoreThanAvailable : false;
            const errorMessagePosition = maxInventory !== '' && itemCountForVariant === maxInventoryCount ? 'form' : 'cart';

            if (this.productForm.element.form) {
              this.productForm.element.form.setAttribute(attributes.maxInventoryReached, maxInventoryReached);
              this.productForm.element.form.setAttribute(attributes.errorMessagePosition, errorMessagePosition);
            }
          })
          .catch((error) => console.log('error: ', error));
      }

      optionImagesWidth() {
        if (!this.variantButtons) return;

        let maxItemWidth = 0;

        requestAnimationFrame(() => {
          this.variantOptionImages.forEach((item) => {
            const itemWidth = item.clientWidth;
            if (itemWidth > maxItemWidth) {
              maxItemWidth = itemWidth;
            }
          });

          this.variantButtons.forEach((item) => {
            item.style?.setProperty('--option-image-width', maxItemWidth + 'px');
          });
        });
      }

      getBaseUnit(variant) {
        return variant.unit_price_measurement.reference_value === 1
          ? variant.unit_price_measurement.reference_unit
          : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit;
      }

      subsToggleListeners() {
        const toggles = this.container.querySelectorAll(selectors.subsToggle);

        toggles.forEach((toggle) => {
          toggle.addEventListener(
            'change',
            function (e) {
              const val = e.target.value.toString();
              const selected = this.container.querySelector(`[${selectors.subsChild}="${val}"]`);
              const groups = this.container.querySelectorAll(`[${selectors.subsChild}]`);
              if (selected) {
                selected.classList.remove(classes.hidden);
                const first = selected.querySelector(`[name="selling_plan"]`);
                first.checked = true;
                first.dispatchEvent(new Event('change'));
              }
              groups.forEach((group) => {
                if (group !== selected) {
                  group.classList.add(classes.hidden);
                  const plans = group.querySelectorAll(`[name="selling_plan"]`);
                  plans.forEach((plan) => {
                    plan.checked = false;
                    plan.dispatchEvent(new Event('change'));
                  });
                }
              });
            }.bind(this)
          );
        });
      }

      updateSaleText(formState) {
        if (!this.priceOffWrap) return;

        if (this.productState.planSale) {
          this.updateSaleTextSubscription(formState);
        } else if (this.productState.onSale) {
          this.updateSaleTextStandard(formState);
        } else {
          this.priceOffWrap.classList.add(classes.hidden);
        }
      }

      isVariantMetafield(variant, metafieldType) {
        const searchScope = this.closest(selectors.productUpsell) || this.container;
        const metafieldsElement = searchScope.querySelector(selectors.variantMetafields);
        const metafieldsData = metafieldsElement ? metafieldsElement.textContent : null;

        if (!metafieldsData) return false;

        const variantsMetafields = JSON.parse(metafieldsData);
        let variantHasMetafield = false;

        variantsMetafields.forEach((variantMetafield) => {
          if (Number(variantMetafield.variant_id) === variant.id) {
            variantHasMetafield = variantMetafield[metafieldType] === 'true';
          }
        });

        return variantHasMetafield;
      }

      isVariantFinalSale(variant) {
        return this.isVariantMetafield(variant, 'final_sale');
      }

      isVariantPreorder(variant) {
        return this.isVariantMetafield(variant, 'preorder');
      }

      updateSaleTextStandard(formState) {
        const variant = formState.variant;
        const finalSaleBadge = this.priceOffWrap?.querySelector(selectors.finalSaleBadge);
        const priceOffBadge = this.priceOffWrap?.querySelector(selectors.priceOffBadge);
        const comparePrice = variant?.compare_at_price;
        const salePrice = variant?.price;

        // Set sale type text if element exists
        if (this.priceOffType) {
          this.priceOffType.innerHTML = window.theme.strings.sale || 'sale';
        }

        // If priceOffBadge or priceOffAmount are missing, hide priceOffBadge and exit early
        if (!priceOffBadge || !this.priceOffAmount || !comparePrice || comparePrice <= salePrice) {
          priceOffBadge?.classList.add(classes.hidden);
        } else {
          // Calculate and display discount
          const {saleType} = priceOffBadge.dataset;
          let discountText;

          if (saleType == 'money') {
            discountText = window.theme.formatMoney(Math.round(comparePrice - salePrice), theme.moneyFormat);
          }

          if (saleType == 'percentage') {
            discountText = `${Math.round(((comparePrice - salePrice) / comparePrice) * 100)}%`;
          }

          if (discountText) {
            this.priceOffAmount.innerHTML = discountText;
            priceOffBadge.classList.remove(classes.hidden);
          }
        }

        // Display or hide the final sale badge
        const isFinalSale = this.priceOffWrap?.hasAttribute(attributes.finalSale) || this.isVariantFinalSale(variant);
        if (finalSaleBadge) {
          finalSaleBadge.classList.toggle(classes.hidden, !isFinalSale);
        }

        this.priceOffWrap.classList.remove(classes.hidden);
      }

      updateSubscriptionText(formState) {
        if (formState.plan && this.planDescription) {
          this.planDescription.innerHTML = formState.plan.detail.description;
          this.planDescription.classList.remove(classes.hidden);
        } else if (this.planDescription) {
          this.planDescription.classList.add(classes.hidden);
        }
      }

      updateSaleTextSubscription(formState) {
        if (this.priceOffType) {
          this.priceOffType.innerHTML = window.theme.strings.subscription || 'subscripton';
        }
        if (this.priceOffAmount && this.priceOffWrap) {
          const adjustment = formState.plan.detail.price_adjustments[0];
          const discount = adjustment.value;
          if (adjustment && adjustment.value_type === 'percentage') {
            this.priceOffAmount.innerHTML = `${discount}%`;
          } else {
            this.priceOffAmount.innerHTML = window.theme.formatMoney(discount, theme.moneyFormat);
          }
          this.priceOffWrap.classList.remove(classes.hidden);
        }
      }

      updateProductPrices(formState) {
        const variant = formState.variant;
        const plan = formState.plan;
        const priceWrappers = this.container.querySelectorAll(selectors.priceWrapper);

        priceWrappers.forEach((wrap) => {
          const comparePriceEl = wrap.querySelector(selectors.comparePrice);
          const productPriceEl = wrap.querySelector(selectors.productPrice);
          const comparePriceText = wrap.querySelector(selectors.comparePriceText);

          let comparePrice = '';
          let price = '';

          if (this.productState.available) {
            comparePrice = variant.compare_at_price;
            price = variant.price;
          }

          if (this.productState.hasPlan) {
            price = plan.allocation.price;
          }

          if (this.productState.planSale) {
            comparePrice = plan.allocation.compare_at_price;
            price = plan.allocation.price;
          }

          if (comparePriceEl) {
            if (this.productState.onSale || this.productState.planSale) {
              comparePriceEl.classList.remove(classes.hidden);
              comparePriceText.classList.remove(classes.hidden);
              productPriceEl.classList.add(classes.productPriceSale);
            } else {
              comparePriceEl.classList.add(classes.hidden);
              comparePriceText.classList.add(classes.hidden);
              productPriceEl.classList.remove(classes.productPriceSale);
            }
            comparePriceEl.innerHTML = window.theme.formatMoney(comparePrice, theme.moneyFormat);
          }

          productPriceEl.innerHTML = price === 0 ? window.theme.strings.free : window.theme.formatMoney(price, theme.moneyFormat);
        });

        if (this.hasUnitPricing) {
          this.updateProductUnits(formState);
        }
      }

      updateProductUnits(formState) {
        const variant = formState.variant;
        const plan = formState.plan;
        let unitPrice = null;

        if (variant && variant.unit_price) {
          unitPrice = variant.unit_price;
        }
        if (plan && plan.allocation && plan.allocation.unit_price) {
          unitPrice = plan.allocation.unit_price;
        }

        if (unitPrice) {
          const base = this.getBaseUnit(variant);
          const formattedPrice = window.theme.formatMoney(unitPrice, theme.moneyFormat);
          this.container.querySelector(selectors.unitPrice).innerHTML = formattedPrice;
          this.container.querySelector(selectors.unitBase).innerHTML = base;
          this.container.querySelector(selectors.unitWrapper).classList.remove(classes.hidden);
        } else {
          this.container.querySelector(selectors.unitWrapper).classList.add(classes.hidden);
        }
      }

      updateSku(formState) {
        if (!this.skuWrapper) return;

        this.skuWrapper.innerHTML = `${theme.strings.sku}: ${formState.variant.sku}`;
      }

      fireHookEvent(formState) {
        const variant = formState.variant;
        this.container.dispatchEvent(
          new CustomEvent('theme:variant:change', {
            detail: {
              variant: variant,
            },
            bubbles: true,
          })
        );
      }

      /**
       * Tracks aspects of the product state that are relevant to UI updates
       * @param {object} evt - variant change event
       * @return {object} productState - represents state of variant + plans
       *  productState.available - current variant and selling plan options result in valid offer
       *  productState.soldOut - variant is sold out
       *  productState.onSale - variant is on sale
       *  productState.showUnitPrice - variant has unit price
       *  productState.requiresPlan - all the product variants requires a selling plan
       *  productState.hasPlan - there is a valid selling plan
       *  productState.planSale - plan has a discount to show next to price
       *  productState.planPerDelivery - plan price does not equal per_delivery_price - a prepaid subscription
       */
      setProductState(dataset) {
        const variant = dataset.variant;
        const plan = dataset.plan;

        const productState = {
          available: true,
          soldOut: false,
          onSale: false,
          showUnitPrice: false,
          requiresPlan: false,
          hasPlan: false,
          planPerDelivery: false,
          planSale: false,
        };

        if (!variant || (variant.requires_selling_plan && !plan)) {
          productState.available = false;
        } else {
          if (!variant.available) {
            productState.soldOut = true;
          }

          if (variant.compare_at_price > variant.price) {
            productState.onSale = true;
          }

          if (variant.unit_price) {
            productState.showUnitPrice = true;
          }

          if (this.product && this.product.requires_selling_plan) {
            productState.requiresPlan = true;
          }

          if (plan && this.subPrices) {
            productState.hasPlan = true;
            if (plan.allocation.per_delivery_price !== plan.allocation.price) {
              productState.planPerDelivery = true;
            }
            if (variant.price > plan.allocation.price) {
              productState.planSale = true;
            }
          }
        }
        return productState;
      }

      updateProductImage(evt) {
        const variant = evt.dataset?.variant || evt.variant;

        if (variant) {
          // Update variant image, if one is set
          if (variant.featured_media) {
            const selectedImage = this.container.querySelector(`[${attributes.imageId}="${variant.featured_media.id}"]`);
            // If we have a mobile breakpoint or the tall layout is disabled,
            // just switch the slideshow.

            if (selectedImage) {
              const selectedImageId = selectedImage.getAttribute(attributes.mediaId);
              const isDesktopView = !window.theme.isMobile();

              selectedImage.dispatchEvent(
                new CustomEvent('theme:media:select', {
                  bubbles: true,
                  detail: {
                    id: selectedImageId,
                  },
                })
              );

              if (isDesktopView && !this.productImages.hasAttribute(attributes.faderDesktop) && this.variantImageScroll) {
                const selectedImageTop = selectedImage.getBoundingClientRect().top;

                // Scroll to variant image
                document.dispatchEvent(
                  new CustomEvent('theme:tooltip:close', {
                    bubbles: false,
                    detail: {
                      hideTransition: false,
                    },
                  })
                );

                window.theme.scrollTo(selectedImageTop);
              }

              if (!isDesktopView && !this.productImages.hasAttribute(attributes.faderMobile)) {
                this.productMediaList.scrollTo({
                  left: selectedImage.offsetLeft,
                });
              }
            }
          }
        }
      }

      updateLegend(formState) {
        const variant = formState.variant;
        if (variant) {
          const optionValues = this.container.querySelectorAll(selectors.optionValue);
          if (optionValues.length) {
            optionValues.forEach((optionValue) => {
              const selectorWrapper = optionValue.closest(selectors.optionPosition);
              if (selectorWrapper) {
                const optionPosition = selectorWrapper.getAttribute(attributes.optionPosition);
                const optionIndex = parseInt(optionPosition, 10) - 1;
                const selectedOptionValue = variant.options[optionIndex];
                optionValue.innerHTML = selectedOptionValue;
              }
            });
          }
        }
      }

      /**
       * Updates the color description based on the selected variant
       *
       * @param {Object} formState - The current form state
       * @return {Void}
       */
      updateColorDescription(formState) {
        const variant = formState.variant;

        if (!variant || !this.colorDescription || !this.colorDescriptionData.length) return;

        const variantId = variant.id.toString();
        let description = '';

        for (const item of this.colorDescriptionData) {
          const itemVariantId = item.variant_id.toString();
          if (itemVariantId === variantId && item.metafield_value) {
            description = item.metafield_value;
            break;
          }
        }

        this.colorDescription.textContent = description;

        if (description) {
          this.colorDescription.classList.remove(classes.hidden);
        } else {
          this.colorDescription.classList.add(classes.hidden);
        }
      }
    }
  );
}
